/* eslint-disable react/jsx-filename-extension */
import { useLocation, Link, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getTopicsConfig } from "../screens/Topics/Topics.config.js";
import { HeaderConfig } from "../models/headerConfig.js";
import { ReactComponent as Chevron } from "../assets/svg/right-chevron.svg";
import { useSpeech } from "./SpeechContext.jsx";
import sfxOn from "../assets/images/SFX-Sound-On.png";
import sfxOff from "../assets/images/SFX-Sound-Off.png";
import { setIsSfxOn } from "../redux/ducks/settingsSlice.js";
import { getString } from "../services/stringsHelpers.js";
import { useLanguage } from "./LanguageContext.jsx";

function getTopicsSettings(strings) {
  return getTopicsConfig(strings).map((configObj) =>
    configObj.toHeaderConfig()
  );
}

function getTopicPageConfig(strs) {
  return {
    text: <h1>{getString("Topics", strs)}</h1>,
    color: "#232232",
    nav: {
      left: null,
      right: () => {
        const location = useLocation();
        const { speak, cancel } = useSpeech();
        const { isSfxOn } = useSelector((state) => state.settings);
        const dispatch = useDispatch();
        const [params] = useSearchParams();
        const isKiosk = params.get("kiosk");
        const { strings } = useLanguage();
        return (
          <div className="app-header__nav app-header__nav--right">
            {!isKiosk ? (
              <button
                type="button"
                onClick={() => {
                  dispatch(setIsSfxOn(isKiosk ? true : !isSfxOn));
                }}
                className="sfx app-header__nav__item"
              >
                <img
                  src={isSfxOn ? sfxOn : sfxOff}
                  alt={`${getString(
                    "Sound effects toggle - currently",
                    strings
                  )} ${
                    isSfxOn
                      ? getString("on", strings)
                      : getString("off", strings)
                  }`}
                  className="app-header__nav__icon"
                />
              </button>
            ) : null}
            {location.state ? (
              <Link
                aria-label={getString("Return to group chat", strings)}
                to={location.state}
                onFocus={() => {
                  cancel();
                  speak({
                    text: getString("Return to group chat, link", strings),
                    forSr: false,
                  });
                }}
                className="app-header__nav__item"
              >
                <Chevron
                  className="app-header__nav__icon"
                  style={{ height: "1.7em" }}
                />
              </Link>
            ) : null}
          </div>
        );
      },
    },
  };
}

export function getSettings(strings) {
  return [
    new HeaderConfig({
      route: "/chatbot/chat",
      ...getTopicPageConfig(strings),
    }),
    new HeaderConfig({
      route: "/",
      ...getTopicPageConfig(strings),
    }),
    ...getTopicsSettings(strings),
  ];
}
